import React, { Fragment, useEffect, useState } from "react";
import { iAxios } from "../../lib/utils";
import moment from 'moment';
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { alertMessage, fetchUserInfo } from "../../lib/actions";


const UsersStatus = () => {

  const [query, setQuery] = useState('');
  const [loc, setLoc] = useState(null);
  const dispatch = useDispatch();
  const { userInfo } = useSelector(st => ({
    userInfo: st.userInfo
  }));

  useEffect(() => {
    const timer = setInterval(() => {
      fetchUserInfo(false);
    }, 60 * 1000);
    return () => {
      clearInterval(timer);
    };
  }, [1]);

  useEffect(() => {
    let icons = ['✅', '🚀', '🎯'];
    let info = userInfo.checkinStatus;
    if (userInfo.checkinStatus === 'Out') {
      icons = ['❌', '🚫', '🛑'];
    }
    if (userInfo.checkinStatus === 'In' && Date.now() - userInfo.heartbeatTm > 300e3 && userInfo.autoCheckoutSec > 0) {
      icons = ['❗'];
      info = 'No Update';
    }
    icons.sort((a, b) => Math.random() - Math.random());
    document.title = `${icons[0]}  Focuz (${info})`;
  }, [userInfo]);

  useEffect(() => {
    const qs = new URLSearchParams();
    const token = localStorage.getItem('access_token');
    qs.set('token', token);
    qs.set('server', document.location.origin);

    if (!navigator.geolocation) {
      setQuery(qs.toString());
      return;
    }

    navigator.geolocation.getCurrentPosition((data) => {
      qs.set('lat', data.coords.latitude);
      qs.set('lon', data.coords.longitude);
      qs.set('acc', data.coords.accuracy);
      setQuery(qs.toString());
      setLoc({
        lat: data.coords.latitude,
        lon: data.coords.longitude,
        acc: data.coords.accuracy
      });
    }, (err) => {
      console.error(err);
      dispatch({
        type: 'show-modal',
        name: 'locationError',
        data: `You need to enable location Permission to Checkin`
      });
    });
  }, [userInfo?.email]);

  const handleInOut = async () => {
    const prevStat = userInfo.checkinStatus;
    const resp = await dispatch(fetchUserInfo());
    if (prevStat !== resp.data.user.checkinStatus) {
      return;
    }

    const data = Object.assign({
      action_group: 'In',
      action: 'Punch In',
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }, loc);

    if (userInfo.checkinStatus === 'In') {
      data.action_group = 'Out';
      data.action = 'Punch Out';
    }

    iAxios.post('/api/v1/user-log', data).then(resp => {
      if (!resp.data.success) {
        dispatch(alertMessage(resp.data.message, 'Error While Checkin'));
      }
      dispatch({
        type: 'SET_USER_INFO',
        data: resp.data.data.user
      });
    });
  };

  const isIn = userInfo.checkinStatus === 'In';
  const isWarn = isIn && Date.now() - userInfo.heartbeatTm > 300e3 && userInfo.autoCheckoutSec > 0;
  const dotCls = classNames('ds-status__dot', {
    'is-warn': isWarn,
    'is-in': isIn && !isWarn,
    'is-out': !isIn
  });

  const usesCopilot = parseInt(userInfo.autoCheckoutSec) !== -1;
  const copilotLabel = (userInfo.heartbeatTm < Date.now() - 12e4 && isIn) ? 'Open Copilot' : 'Copilot Checkin';

  return (
    <Fragment>
      <span className="ds-status">
        <span className={dotCls} aria-hidden="true" />
        {userInfo.data && (
          <>
            {userInfo.data.status}
            <span className="ds-status__meta">· {moment.unix(userInfo.data.statusTime / 1000).fromNow()}</span>
          </>
        )}
      </span>

      {usesCopilot && query !== '' && (
        <a className="ds-btn is-soft is-sm" href={`zcalo://login/?${query}`}>
          {copilotLabel}
        </a>
      )}
      {!usesCopilot && query !== '' && (
        <button type="button" onClick={handleInOut} className="ds-btn is-soft is-sm" title={userInfo.checkinStatus}>
          {isIn ? 'Punch Out' : 'Punch In'}
        </button>
      )}
    </Fragment>
  );
};

export default UsersStatus;
